import ConnectionUtil from "shared/connection_util";
import { VidioHelpers } from 'shared/vidio_helpers';
import Uap from 'shared/uap/uap';

export default class AhoyEvent {

  static send(eventLabel, eventData) {
    const generatedEventData = this.generateEventData(eventData);
    window.ahoy.track(eventLabel, generatedEventData);

    if (VidioHelpers.getQueryParameter(location.search, 'ahoy_debug') === '1') {
      console.warn(eventLabel, "+++", JSON.stringify(generatedEventData));
    }
  }

  static generateEventData(eventData) {
    this._uaParser = this._uaParser || new Uap();
    this._connectionUtil = this._connectionUtil || new ConnectionUtil();

    var ahoyData = {
      platform: VidioHelpers.getPlatform(),
      app_name: 'vidio',
      page: window.location.href,
      referrer: VidioHelpers.getReferrer(),
      ga_client_id: this.getGaClientId() || null,
      browser_name: this._uaParser.getBrowser().name,
      browser_version: this._uaParser.getBrowser().version,
      device_brand: this._uaParser.getDevice().vendor,
      device_model: this._uaParser.getDevice().model,
      os_name: this._uaParser.getOS().name,
      os_version: this._uaParser.getOS().version,
      connection: this._connectionUtil.getConnectionEffectiveType()
    };
    if(VidioHelpers.isPremiumUser()) {
      ahoyData.user_type = "premier";
    }

    for(var index in eventData) {
      ahoyData[this.snakeCase(index)] = eventData[index];
    }

    AhoyEvent.extendProperties(ahoyData, eventData);
    return ahoyData;
  }

  static extendProperties(data, newData) {
    for(var index in newData) {
      data[AhoyEvent.snakeCase(index)] = newData[index];
    }

    return data;
  }

  static snakeCase(string) {
    return string.replace(/[A-Z][a-z]*/g, (x) => {return "_" + x.toLowerCase();});
  }

  static getGaClientId() {
    if(!window.ga) return null;

    var clientId;
    window.ga(function(tracker) {
      clientId = tracker.get('clientId');
    });
    return clientId;
  }
}
